import { Component } from '@angular/core';

@Component({
  selector: 'app-precision-industries',
  templateUrl: './precision-industries.component.html',
  styleUrls: ['./precision-industries.component.scss']
})
export class PrecisionIndustriesComponent {

}
